// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box8 input[type=text][data-v-0e38c810] {\n  width: 200px;\n}", ""]);
// Exports
module.exports = exports;
